import { BookOpenIcon } from "@heroicons/react/24/outline";
import { HelpCenterArticleKey, helpCenterArticleUrl } from "@sp-crm/core";
import { SidebarMode } from "components/layout/sidebar";
import React from "react";
import { useHelpCenter } from "store/selectors/hooks";
import { NgSidebarItem } from "./ng-sidebar-item";
import { WhiteLabelRestricted } from "./white-label-restricted";

interface DocLinkProps {
    article: HelpCenterArticleKey;
    children: React.ReactNode;
    className?: string;
}

export const DocLink: React.FC<DocLinkProps> = ({ article, children, className }) => {
    const helpCenter = useHelpCenter();
    if (!helpCenter) {
        return null;
    }
    return (
        <WhiteLabelRestricted>
            <a
                href={helpCenterArticleUrl(helpCenter, article)}
                target="_blank"
                rel="noreferrer"
                className={className}>
                {children}
            </a>
        </WhiteLabelRestricted>
    );
};

export const DocLinkSidebarItem: React.FC<{ mode: SidebarMode }> = ({ mode }) => {
    const helpCenter = useHelpCenter();
    if (!helpCenter) {
        return null;
    }
    return (
        <WhiteLabelRestricted>
            <NgSidebarItem
                href={helpCenter.tutorialsUrl}
                current={false}
                icon={BookOpenIcon}
                label="Tutorials"
                mode={mode}
            />
        </WhiteLabelRestricted>
    );
};
